let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("6QOF8")).then(() => parcelRequire('mD7UB'));